import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

/**
 * This will append jwt token for the http requests.
 *
 * @export
 * @class JwtInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    with_auth_request: HttpRequest<any>;

    constructor(private router: Router,) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return from(Auth.currentSession())
            .pipe(
                switchMap((auth: any) => { // switchMap() is used instead of map().
                    // this will be removed 
                    let jwt = auth.accessToken.jwtToken;
                    let idT = auth.idToken.jwtToken;
                    // let uuid = auth.customOAuthState;
                    // --
                    // if(request.url.includes('/api/createAuthorizationToken')){
                    //     this.with_auth_request = request.clone({
                    //         setHeaders: {
                    //             Authorization: `Bearer ${jwt}`,
                    //             UserIDReference: `${idT}`
                    //         }
                    //     });
                    // }else{
                    //     this.with_auth_request = request.clone({
                    //         setHeaders: {
                    //             Authorization: `Bearer ${jwt}`
                    //         }
                    //     });
                    // }

                    this.with_auth_request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${jwt}`,
                            UserIDReference: `${idT}`
                        }
                    });
                    
                    return next.handle(this.with_auth_request);
                }),
                catchError((err) => {
                    if(request.url.includes('/api/getUserDetails') || request.url.includes('/api/createAuthorizationToken')){
                        this.router.navigate(['auth/unauthorized']);
                    }
                    console.log("Error ", err);
                    return next.handle(request);
                })
            );
        
    }

}